import useGlobalInfo from './useGlobalInfo';

export default useGlobalInfo;
